export function roundTwoDecimals(value?: number) {
    return value != null
        ? Math.round((value + Number.EPSILON) * 100) / 100
        : 0;
}
